<div class="alert alert-success"> 
  <ng-content></ng-content>
</div>
